import styled from 'styled-components';

export const StyledUnityPlayer = styled.div`
  border: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.frame};
  position: absolute;
  z-index: 199;
  left: ${({ theme }) => theme.frameOffset};
  right: ${({ theme }) => theme.frameOffset};
  top: ${({ theme }) => theme.navHeight};
  bottom: ${({ theme }) => theme.frameOffset};
`;

export const CornerLT = styled.div`
  width: ${({ theme }) => theme.cornerSize};
  height: ${({ theme }) => theme.cornerSize};
  border: solid ${({ theme }) => theme.frameWidth} white;
  position: absolute;
  animation: corner-scale 0.3s cubic-bezier(0.5, 0.35, 0.15, 1) 0.1s 1 normal forwards;

  border-right: none;
  border-bottom: none;
  margin-top: ${({ theme }) => '-' + theme.frameWidth};
  margin-left: ${({ theme }) => '-' + theme.frameWidth};
  top: 0;
  left: 0;
`;

export const CornerRT = styled.div`
  width: ${({ theme }) => theme.cornerSize};
  height: ${({ theme }) => theme.cornerSize};
  border: solid ${({ theme }) => theme.frameWidth} white;
  position: absolute;
  animation: corner-scale 0.3s cubic-bezier(0.5, 0.35, 0.15, 1) 0.1s 1 normal forwards;

  border-left: none;
  border-bottom: none;
  margin-top: ${({ theme }) => '-' + theme.frameWidth};
  margin-right: ${({ theme }) => '-' + theme.frameWidth};
  top: 0;
  right: 0;
`;

export const CornerRB = styled.div`
  width: ${({ theme }) => theme.cornerSize};
  height: ${({ theme }) => theme.cornerSize};
  border: solid ${({ theme }) => theme.frameWidth} white;
  position: absolute;
  animation: corner-scale 0.3s cubic-bezier(0.5, 0.35, 0.15, 1) 0.1s 1 normal forwards;

  border-left: none;
  border-top: none;
  margin-bottom: ${({ theme }) => '-' + theme.frameWidth};
  margin-right: ${({ theme }) => '-' + theme.frameWidth};
  bottom: 0;
  right: 0;
`;

export const CornerLB = styled.div`
  width: ${({ theme }) => theme.cornerSize};
  height: ${({ theme }) => theme.cornerSize};
  border: solid ${({ theme }) => theme.frameWidth} white;
  position: absolute;
  animation: corner-scale 0.3s cubic-bezier(0.5, 0.35, 0.15, 1) 0.1s 1 normal forwards;

  border-right: none;
  border-top: none;
  margin-bottom: ${({ theme }) => '-' + theme.frameWidth};
  margin-left: ${({ theme }) => '-' + theme.frameWidth};
  bottom: 0;
  left: 0;
`;

export const PlayerWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

export const LoadingTunnel = styled.img`
  top: 0;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  transition: linear 0.2s;
  object-fit: cover;
`;

export const LoadingScreenWrapper = styled.div`
  top: 0;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  border: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.frame};
`;

export const LoadingScreenContent = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

export const LoadingInfo = styled.div`
  top: 0;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  gap: 0.5rem;
  padding: 1rem;
  padding-bottom: 3.5rem;

  @media (max-height: 640px) {
    padding: 0.5rem;
    padding-bottom: 2.5rem;
  }
`;

export const PrepareForBattle = styled.img`
  position: absolute;
  width: auto;
  top: 30%;
  object-fit: contain;
  height: calc(30vh);
  transform: translateX(8%) translateY(-50%);
`;

export const PrepareForBattleStyled = styled.img`
  height: 16vh;
  max-height: 150px;
  object-fit: contain;
  max-width: 100%;
  
  @media (max-height: 640px) {
    height: 14vh;
  }
`;

export const LoadingCenterContent = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-75%);
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const LoadingBottomContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
`;

export const CenterPanel = styled.div`
  height: 10.5rem;
  width: 38.25rem;
  position: relative;

  @media (max-height: 640px) {
    height: 8rem;
  }
`;

export const Fight = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`; 

export const Prepare = styled.img`
  object-fit: contain;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
`;

export const TopPlayers = styled.div`
  display: flex;
  min-height: 15%;
  flex-shrink: 0;
  flex-direction: row;
  align-items: start;
  justify-content: center;
  width: 100%;
  overflow: hidden;
`;

export const Vs = styled.img`
  height: 2.75rem;
  width: 5.625rem;
`;

export const XpIcon = styled.img`
  height: 2rem;
  width: 2rem;
  @media (max-width: 1440px) {
    height: 1.75rem;
    width: 1.75rem;
  }
`;

export const PlayerInfo = styled.div`
  padding-left: 1rem;
  padding-right: 1rem;
  text-transform: uppercase;
  font-family: "NeueMachina";
  font-size: 4rem;
  font-weight: 800;
  display: flex;
  flex-direction: column;
  justify-content: start;
  width: calc((100% - 5.625rem) / 2);
  align-items: ${({ $opponent }) => $opponent ? 'end' : 'start'};
  .xp {
    font-size: 2rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
    div {
      padding-top: 5%;
    }
  }

  @media (max-width: 1440px) {
    font-size: 3.725rem;
    .xp {
      font-size: 1.75rem;
    }
  }

  @media (max-width: 1360px) {
    font-size: 3.25rem;
    .xp {
      font-size: 1.375rem;
    }
  }
  
  @media (max-width: 1280px) {
    font-size: 2.75rem;
    .xp {
      font-size: 1.125rem;
    }
  }
  
  @media (max-width: 1080px) {
    font-size: 2.25rem;
    .xp {
      font-size: 1rem;
    }
  }

  @media (max-width: 900px) {
    font-size: 2rem;
    .xp {
      font-size: 1rem;
    }
  }

  @media (max-height: 640px) {
    font-size: 2rem;
    .xp {
      font-size: 1rem;
    }
  }
`;

export const LoadingStatusWrapper = styled.div`
  position: absolute;
  bottom: 3.5rem;
  right: 1rem;
  width: 30vw;
  flex-shrink: 0;
  z-index: 2; 
  padding-right: 3px;
  display: flex;
  flex-direction: column;
  align-items:flex-end;
  justify-content: flex-end;
  gap: 0.5rem;

  @media (max-height: 640px) {
    bottom: 2.5rem;
    right: 0.5rem;
  }
`;

export const QueueStatusContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
`;

export const QueueStatusWrapper = styled.div`
  position: absolute;
  bottom: 3.5rem;
  left: 1rem;
  width: 30vw;
  flex-shrink: 0;
  z-index: 2; 
  padding-right: 3px;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 0.5rem;

  @media (max-height: 640px) {
    bottom: 2.5rem;
    right: 0.5rem;
  }
`;

export const LoadingLevelCaption = styled.div`
  font-family: "NeueMachina";
  font-size: 1.2rem;
  font-weight: 800;
  color: white;
  line-height: 1.2;
  text-shadow: 1px 1px 8px black;
`;

export const QueueStatusTitle = styled.div`
  font-family: "NeueMachina";
  font-size: 1.2rem;
  font-weight: 800;
  color: white;
  line-height: 1.2;
  text-shadow: 1px 1px 8px black;
`;

export const QueueStatusValue = styled.div`
  font-family: "NeueMachina";
  font-size: 1.5rem;
  font-weight: 800;
  color: white;
  line-height: 1.2;
  text-shadow: 1px 1px 8px black;
`;

export const LoadingBarWrapper = styled.div`
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  width: calc(100% - 2rem);
  border: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.inputBorder};
  background: ${({ theme }) => theme.buttonDark};
  height: 2rem;
  @media (max-height: 640px) {
    height: 1.75rem;
    bottom: 0.5rem;
    left: 0.5rem;
    width: calc(100% - 1rem);
  }
`;

export const LoadingBar = styled.div`
  height: 100%;
  background: ${({ theme }) => theme.buttonGreen};
`;

export const LoadingBarText = styled.div`
  height: 100%;
  color: ${({ theme }) => theme.buttonDark};
  font-family: "NeueMachina";
  font-weight: 600;
  font-size: 1.2rem;
  padding-top: 0.35rem;
  padding-left: 0.5rem;
  position: absolute;
  top: 0;
  left: 0;

  @media (max-height: 640px) {
    font-size: 1rem;
    padding-top: 0.25rem;
    padding-left: 0.25rem;
  }
`;

export const LoadingStatus = styled.div`
  width: 10vw;
  background: ${({ theme }) => theme.buttonDark};
  font-family: "NeueMachina";
  font-size: 1rem;
  font-weight: 400;
  color: white;
  /* height: 7rem; */
  /* border: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.inputBorder}; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const LoadingStatusText = styled.div`
  width: 100%;
  padding: 1rem;
  height: 100%;
`;

export const Skull = styled.img`
  width: 2rem;
  height: 2rem;
`;

export const LoadingPortraits = styled.div`
  background-color: ${({ theme }) => theme.brightBlue};
  top: 0;
  position: relative;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  z-index: 0;
  
  &:after {
    content: '';
    position: absolute;
    z-index: 2;
    bottom: 0;
    width:100%;
    left: 0;
    height: 50vh;
    background: linear-gradient(180deg, rgba(26, 44, 243, 0) 39.52%, #1A2CF3 89.52%);
  }
`;

export const LoadingSeparatorBar = styled.div`
  background-color: ${({ theme }) => theme.background};
  width: 7vw;
  height:120%;
  top: -10%;
  left: 50%;
  transform: translateX(-50%) rotate(16deg);
  position: absolute;
`;

export const PortraitOpponent = styled.div`
  height: 100%;
  width: auto;
  animation: fly-in-bounce 0.35s ease-out forwards;
  transform: translateX(100vw);
  will-change: transform;

  img {
    transform: scaleX(-1);
    width: 100%;
    height: 100%;
  }
`;

export const PortraitMy = styled.div`
  height: 100%;
  width: auto;
  animation: fly-in-bounce-my 0.35s ease-out forwards;
  transform: translateX(100vw);
  will-change: transform;

  img {
    width: 100%;
    height: 100%;
  }
`;
